import React from 'react'

const LogoImage = ({style}) => {
    return (
        <div className="logo-image" style={style}></div>
    )
}

export default LogoImage;